export const RULES_TEXTAREA_MAX_LENGTH = 3000;
